export enum SubscriptionType {
  PayPerUse = 0,
  Personal = 1,
  BusinessMonth = 2,
}

export enum SubscriptionStatus {
  Active = 1,
  PastDue = 2,
  Unpaid = 3,
  Canceled = 4,
}

export enum PackageStatus {
  New = 1,
  Received = 2,
  ReceivedDamaged = 3,
  Scheduled = 4,
  Picked = 5,
  Delivered = 6,
  Returned = 7,
  Refused = 8,
  Disposed = 9,
  Deleted = 10,
  Cancelled = 11,
  ReceivedEmpty = 13,
  ReceivedAtWareHouse = 14,
  Redirect = 15,
  PendingUnload = 16,
}

export enum MobileFilterType {
  Courier = 0,
  Status = 1,
  ReceivedDateRange = 2,
  PickedDateRange = 3,
  CourierText = 4,
  Toggle = 5,
}

export enum PaymentStatus {
  NotCreated = 0,
  Pending = 1,
  Successful = 2,
  Failed = 3,
  Authorized = 5
}